import { Button, Dropdown } from '@iveco-ti/iveco-ds'
import { ChevronDown, FileSpreadsheet, FileText, FileUp } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { FeatureFlag } from './FeatureFlag'

type ExportDropdownProps = {
  onExportCSV: () => void
  onExportXLSX: () => void
  isExporting: boolean
}

export function ExportDropdown({
  onExportCSV,
  onExportXLSX,
  isExporting,
}: ExportDropdownProps) {
  const { t } = useTranslation('common')

  return (
    <FeatureFlag flag="export_dropdown">
      <Dropdown.Root>
        <Dropdown.Trigger asChild>
          <Button.Root
            color="brand"
            variant="secondary"
            size="sm"
            disabled={isExporting}
            isLoading={isExporting}
          >
            <Button.Icon icon={FileUp} />
            {t('components.export_dropdown.trigger.label')}
            <Button.Icon icon={ChevronDown} />
          </Button.Root>
        </Dropdown.Trigger>

        <Dropdown.Body>
          <Dropdown.List>
            <Dropdown.Item color="brand" onClick={() => onExportCSV()}>
              <Dropdown.Icon icon={<FileText size={16} />} />
              {t('components.export_dropdown.options.csv')}
            </Dropdown.Item>

            <Dropdown.Item color="brand" onClick={() => onExportXLSX()}>
              <Dropdown.Icon icon={<FileSpreadsheet size={16} />} />
              {t('components.export_dropdown.options.xlsx')}
            </Dropdown.Item>
          </Dropdown.List>
        </Dropdown.Body>
      </Dropdown.Root>
    </FeatureFlag>
  )
}
